<div class="bmc-provider-container">
  <h5>{{'PROVIDERS.HEADING' | translate}}</h5>
  <div class="bmc-provider-container__header-container">
    <div class="bmc-provider-container__external-system-section">
        <label class="bmc-provider-select__external-system-title">
          {{'PROVIDERS.EXTERNAL_SYSTEM' | translate}}</label>
        <bzg-select [placeholder]="'PROVIDERS.SELECT_EXTERNAL_SYSTEM' | translate"
            (valueChange)="selectExternalSystem($event)">
            <bzg-option *ngFor="let externalSystem of externalSystems" [value]="externalSystem">
                {{externalSystem.displayName}}
            </bzg-option>
        </bzg-select>
    </div>
  </div>
  <div class="bmc-provider">
    <div class="bmc-provider-select">
      <div class="bmc-provider-select__list-section" *ngIf="selectedExternalSystem">
        <label class="bmc-provider-select__title" *ngIf="selectedExternalSystem.nodes">{{'PROVIDERS.TITLE_SELECT' | translate}}</label>
        <label class="bmc-provider-select__title" *ngIf="!selectedExternalSystem.nodes">{{'PROVIDERS.WITHOUT_NODES' | translate}}</label>
        <connect-provider-tree class="bmc-provider-select__list" [itemsTree]="selectedExternalSystem.nodes" [currentItemSelected]="currentItemSelected" (selectedItem)="selectItem($event)"></connect-provider-tree>
      </div>
      <div class="bmc-provider-select__without-selection" *ngIf="!selectedExternalSystem">
        <img class="bmc-provider-select__image bmc-provider-select__block" src="assets/img/bg-no-item-selected.png" alt="External system"/>
        <div class="bmc-provider-select__title bmc-provider-select__block">{{'PROVIDERS.WITHOUT_SELECT' | translate}}</div>
      </div>
    </div>

    <div *ngIf="selectedExternalSystem" class="bmc-provider-config">

        <div class="bmc-provider-config__list" *ngIf="currentItemSelected">
          <connect-provider-detail  *ngIf="currentItemSelected.type === 'Provider'" [currentItemSelected]="currentItemSelected"></connect-provider-detail>
          <connect-replication-detail *ngIf="currentItemSelected.type === 'JobScheduler'" [currentItemSelected]="currentItemSelected"></connect-replication-detail>
          <connect-virtualization-detail *ngIf="currentItemSelected.type === 'VirtualEntities'" [guidProvider]="guidProvider"></connect-virtualization-detail>
          <div class="bmc-provider-select__without-selection" *ngIf="currentItemSelected.type === 'ReplicatedEntities'">
            <img class="bmc-provider-select__image bmc-provider-select__block" src="assets/img/bg-no-item-selected.png" alt="External system"/>
            <div class="bmc-provider-select__title bmc-provider-select__block">{{'PROVIDERS.WITHOUT_SELECT_ITEM' | translate}}</div>
          </div>
        </div>

        <div *ngIf="!currentItemSelected">
          <div class="bmc-provider-select__without-selection" *ngIf="!currentItemSelected && selectedExternalSystem">
            <img class="bmc-provider-select__image bmc-provider-select__block" src="assets/img/bg-no-item-selected.png" alt="External system"/>
            <div class="bmc-provider-select__title bmc-provider-select__block">{{'PROVIDERS.SELECT_PROVIDER' | translate}}</div>
          </div>
        </div>
    </div>
  </div>
</div>

